import {ClientInformationService} from "./ClientInformationService";
import {ApplicationService} from "@hec/models";

export const requiredClientInformationServices = (): ApplicationService[] => {
  return [
    new ClientInformationService()
  ];
}
